import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { SecurityAuditLog, SecurityAuditLogCreate, SecurityAuditLogFilter } from '../data/securityAuditLog';

export function createSecurityAuditLogService(client: AxiosInstance) {
  return createCrudService<SecurityAuditLog, SecurityAuditLogCreate, SecurityAuditLogFilter>(
    client,
    '/audit/SecurityAuditLog',
    'id',
  );
}

export type SecurityAuditLogService = CrudService<SecurityAuditLog, SecurityAuditLogCreate, SecurityAuditLogFilter>;
